import { useContext, useEffect, useState } from "react";
import { Badge, Col, Container, Row } from "react-bootstrap";
import ApiService from "../../../../services/api";
import parse from "html-react-parser";
import "../css/body_credits.css";
import { AuthContext } from "../../../../services/auth";

const BodyCredits = () => {
  const { isEnglish } = useContext(AuthContext);
  const [credits, setCredits] = useState({});
  const [category, setCategory] = useState({});
  const [Loading, setLoading] = useState(true);

  const fetchCredits = async () => {
    const Credits = await ApiService.getCredits();
    const creditsCategory = await ApiService.getCategories();
    setCategory(creditsCategory.filter((select) => select.type === "credits"));
    setCredits(Credits);
    setLoading(false);
  };

  useEffect(() => {
    fetchCredits();
  }, []);

  if (Loading) {
    return;
  }

  return (
    <Container fluid className="padding_custom">
      <Container>
        <h2 className="text-center section-title mt-5">CREDITS</h2>
        <div className="border-custom mt-3"></div>
        {category.map((category) => {
          return (
            <div key={category.id}>
              {credits
                .filter((filters) => filters.category === "title")
                .map((title) => {
                  return (
                    <div key={title.id}>
                      <h3 className="text-center section-subtitle mt-5">
                        {isEnglish ? title.title_eng : title.title}
                      </h3>
                      <Row className="p-0 m-0 w-100 h-100 d-flex  justify-content-center ">
                        {credits
                          .filter(
                            (filters) => filters.category === category.name
                          )
                          .map((credits) => {
                            return (
                              <Col
                                key={credits.id}
                                className=" m-5 p-0 container_credits"
                              >
                                <Col className="py-4 m-3 text-center ">
                                  <img
                                    alt=""
                                    src={credits.src}
                                    className="w-100 img_custom_credits"
                                  ></img>
                                  <h4 className="py-3 text_compositions">
                                    {credits.name}
                                  </h4>
                                  <Badge
                                    bg=""
                                    pill
                                    className="text-center badge-text badge_credits"
                                  >
                                    <p className="pb-2 section-text  m-0 py-1 ">
                                      {isEnglish
                                        ? credits.occupation_eng
                                        : credits.occupation}
                                    </p>
                                  </Badge>
                                  <div className="d-flex justify-content-center align-items-center pt-3">
                                    <div className="section-text">
                                      {isEnglish
                                        ? parse(credits.text_eng)
                                        : parse(credits.text)}
                                    </div>
                                  </div>
                                </Col>
                              </Col>
                            );
                          })}
                      </Row>
                    </div>
                  );
                })}
            </div>
          );
        })}
      </Container>
    </Container>
  );
};
export default BodyCredits;
